import { createUseMutationHook } from 'hooks/createUseMutationHook';

export const useChangeCompany = createUseMutationHook('change_company', () => ['auth_meta']);
